import React from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';

const CenteredFeedbackContainer = styled(Box)({
  position: 'sticky', // Absolute to follow the overlay horizontally
  top: '50%', // Fixed vertical center in the viewport
  transform: 'translateY(-50%)', // Center vertically
  zIndex: 23 // Higher z-index to stay above the overlay
});

export default CenteredFeedbackContainer;
